import { render } from "./MainSidebar.vue?vue&type=template&id=00e6e446"
import script from "./MainSidebar.vue?vue&type=script&lang=js"
export * from "./MainSidebar.vue?vue&type=script&lang=js"

import "./MainSidebar.vue?vue&type=style&index=0&id=00e6e446&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__